import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import ChevronRight from '../svg/ChevronRight'

function Next({ active, onClick, style }) {
  return (
    <div onClick={ active ? onClick : null } className={`arrow-link pag-chevron-right`} style={{ ...style, cursor: active ? `pointer` : `default` }}>
      <ChevronRight color={ active ? Config.TYPE_LIGHT : Config.TYPE_PLACEHOLDER } />
    </div>
  )
}

Next.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object
}

export default Next;
